module.exports = __webpack_public_path__ + "img/favicon-hoang-cong.ec7ecefc.png";